import { FC, useState } from "react";
import { AnimatePresence } from "framer-motion";

import {
  ProductionSceneNoteResource,
  ProductionSceneResource,
} from "@/types/resources";
import {
  InfoBlock,
  InfoHeadline,
  PlusButton,
} from "./ProductionScriptBlockInfo";
import Text from "@/components/Text";
import SceneNotesModal from "./SceneNotesModal";

interface Notes {
  notes?: ProductionSceneNoteResource[][];
  scene: ProductionSceneResource;
  sceneNumber: number;
}

const SidebarNotes: FC<Notes> = ({ notes, scene, sceneNumber }) => {
  const [showModal, setShowModal] = useState(false);

  const sceneNotes = notes?.[sceneNumber - 1];

  return (
    <>
      <InfoHeadline
        $type="smallBold"
        as="button"
        type="button"
        onClick={() => setShowModal(true)}
      >
        <PlusButton>
          <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.75 0.749023C3.75 0.33481 3.41421 -0.000976562 3 -0.000976562C2.58579 -0.000976562 2.25 0.33481 2.25 0.749023V2.25098H0.749023C0.33481 2.25098 -0.000976562 2.58676 -0.000976562 3.00098C-0.000976562 3.41519 0.33481 3.75098 0.749023 3.75098H2.25V5.25095C2.25 5.66516 2.58579 6.00095 3 6.00095C3.41421 6.00095 3.75 5.66516 3.75 5.25095V3.75098H5.25095C5.66516 3.75098 6.00095 3.41519 6.00095 3.00098C6.00095 2.58676 5.66516 2.25098 5.25095 2.25098H3.75V0.749023Z"
              fill="currentColor"
            />
          </svg>
        </PlusButton>
        Notes
      </InfoHeadline>
      {!!sceneNotes?.length ? (
        sceneNotes.map((note) => (
          <InfoBlock key={note.id}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.00056 10.2864H5.71484V8.0007L12.572 1.14355L14.8577 3.42927L8.00056 10.2864Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.8574 2.85742L13.1431 5.14314"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.2863 7.42913V13.7148C14.2863 13.8664 14.2261 14.0117 14.1189 14.1189C14.0117 14.2261 13.8664 14.2863 13.7148 14.2863H2.28627C2.13472 14.2863 1.98938 14.2261 1.88221 14.1189C1.77505 14.0117 1.71484 13.8664 1.71484 13.7148V2.28627C1.71484 2.13472 1.77505 1.98938 1.88221 1.88221C1.98938 1.77505 2.13472 1.71484 2.28627 1.71484H8.57199"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <Text $type="smallBold" $color="black">
              {note.content}
            </Text>
          </InfoBlock>
        ))
      ) : (
        <InfoBlock>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.00056 10.2864H5.71484V8.0007L12.572 1.14355L14.8577 3.42927L8.00056 10.2864Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.8574 2.85742L13.1431 5.14314"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.2863 7.42913V13.7148C14.2863 13.8664 14.2261 14.0117 14.1189 14.1189C14.0117 14.2261 13.8664 14.2863 13.7148 14.2863H2.28627C2.13472 14.2863 1.98938 14.2261 1.88221 14.1189C1.77505 14.0117 1.71484 13.8664 1.71484 13.7148V2.28627C1.71484 2.13472 1.77505 1.98938 1.88221 1.88221C1.98938 1.77505 2.13472 1.71484 2.28627 1.71484H8.57199"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <Text $type="smallBold" $color="gray">
            No notes added
          </Text>
        </InfoBlock>
      )}
      <AnimatePresence>
        {!!showModal && (
          <SceneNotesModal scene={scene} onClose={() => setShowModal(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default SidebarNotes;
